import {FC} from 'react';
//mui
import {Box, Divider} from '@mui/material';
//components
import AllSocialItems from './AllSocialItems';
//styles
import {socialFormActionsStyle} from './SocialFormActions.styles';
import {USER_TYPE} from '@/utils/enums';
import {IAuthAppleRequest} from '@/utils/types';

interface SocialFormActionsProps {
	userType?: USER_TYPE;
	onSocialLoginSuccess?: () => void;
	onGoogleSignupSuccess?: (idToken: string) => void;
	onAppleSignupSuccess?: (request: IAuthAppleRequest) => Promise<void>;
}

const SocialFormActions: FC<SocialFormActionsProps> = ({
	userType = USER_TYPE.ORGANIZATION,
	onSocialLoginSuccess,
	onGoogleSignupSuccess,
	onAppleSignupSuccess,
}) => {
	return (
		<Box sx={socialFormActionsStyle.wrapper}>
			<Divider sx={socialFormActionsStyle.divider}>or</Divider>

			<AllSocialItems
				userType={userType}
				onSocialLoginSuccess={onSocialLoginSuccess}
				onGoogleSignupSuccess={onGoogleSignupSuccess}
				onAppleSignupSuccess={onAppleSignupSuccess}
			/>
		</Box>
	);
};

export default SocialFormActions;
